import { render, staticRenderFns } from "./certificateDataDoctorPra.vue?vue&type=template&id=5578dd2a&"
import script from "./certificateDataDoctorPra.vue?vue&type=script&lang=js&"
export * from "./certificateDataDoctorPra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports